import "./App.css";
import { BrowserRouter, Route, NavLink, Routes } from "react-router-dom";

// page components
import Home from "./pages/Home";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <nav>
          <h1>
            <NavLink exact to="/">
              Põhjala mesilased
            </NavLink>
          </h1>
          <NavLink to="/contact">CONTACT</NavLink>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
